class AthleteDetailHeroMedia extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
    this.slideIndex = 0;
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-hero-gallery-slide]'));
    this.speed = Number(this.dataset.speed || 3000);

    if (this.slides.length <= 1) {
      return;
    }
    this.setSlide(0);
    this.startAutoplay();
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  disconnectedCallback() {
    this.clearAutoplay();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  onVisibilityChange() {
    if (document.hidden) {
      this.clearAutoplay();
      return;
    }

    this.startAutoplay();
  }

  startAutoplay() {
    if (this.slides.length <= 1) {
      return;
    }

    this.clearAutoplay();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    this.intervalId = window.setInterval(() => {
      const nextIndex = (this.slideIndex + 1) % this.slides.length;
      this.setSlide(nextIndex);
    }, this.speed);
  }

  setSlide(index) {
    if (!this.slides.length) {
      return;
    }

    const nextIndex = ((index % this.slides.length) + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === nextIndex);
    });

    this.slideIndex = nextIndex;
  }

  clearAutoplay() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

if (!customElements.get('athlete-detail-hero-media')) {
  customElements.define('athlete-detail-hero-media', AthleteDetailHeroMedia);
}
